import React , {useEffect, useState} from 'react';
import { TitleBar } from './appBar';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import {FontAwesome, FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faOctagon, faCircle, faClock } from '@fortawesome/free-solid-svg-icons'
import { IconCell, StatusIcons} from './helpers';

export const WaitTimeStatus=()=>{
    const [listData,setListData]=useState([]);
    
    const getData=()=>{
        const url = "api/index.php/program/getPAList";
        //console.log(url);
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(data=>{
            //console.log(data);
            setListData(data);
        })
    }

   

    const TimeCell = (props) => {
        const retVal = ()=>{
            switch (props.dataItem.Status){
                case "OPEN":
                    //console.log("OPEN");
                    if (props.dataItem.WaitTime<5){
                        return(
                            <span>Less than 5 min</span>
                        )
                    }else{
                        return(
                            <span>{props.dataItem.WaitTime} min</span>
                        )
                    }
                case "CLOSED":
                    //console.log("Closed");
                    return(
                        <span>Closed</span>
                    )
                case "HOLD":
                    //console.log("HOLD");
                    return(
                        <span>On Hold</span>
                    )
                case "CAPACITY":
                    //console.log("HOLD");
                    return(
                        <span>At Capacity</span>
                    )
                default:
                    return(
                        <span>Unknown</span>
                    )
            }
        }
        return (
            <td {...props.tdProps}>
                {retVal()}
            </td>
        );
    };

    useEffect(()=>{
        getData();
        const interval = setInterval(getData, 120000); // Fetch every 2 minutes
            return () => clearInterval(interval); // Cleanup
    },[])
    return(
         <div>
            <TitleBar title="Estimated Wait Times"></TitleBar>
            <div style={{padding:"10px"}}>
                {StatusIcons({status:"OPEN",size:"large"})} OPEN&emsp;
                {StatusIcons({status:"CLOSED",size:"large"})} CLOSED&emsp;               
                {StatusIcons({status:"HOLD",size:"large"})} HOLD&emsp;               
                {StatusIcons({status:"CAPACITY",size:"large"})} FULL&emsp;               
            </div>
            <div style={{padding:"10px"}}>
            <Grid
                data={listData}
                dataItemKey={"AreaID"}
            >
                <GridColumn
                    field="Status"
                    title="Status"
                    cells={{data:IconCell}}
                    width={"75px"}
                />
                <GridColumn
                    field="AreaName"
                    title="Area Name"
                />
                <GridColumn
                    field="WaitTime"
                    title="Wait (Minutes)"
                    cells={{data:TimeCell}}
                />
            </Grid>
            </div>
        </div>
    )
}